import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";
// import moment from 'moment';

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchProjectPlans } from 'Redux/Admin/ProjectManager/ProjectPlans/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { IProjectPlan } from 'Redux/Admin/ProjectManager/ProjectPlans/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const columns: TableColumnsType<IProjectPlan> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/project-manager/project-plans/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 280,
  },
  {
    title: 'Owner',
    dataIndex: 'owner',
    key: 'owner',
    width: 120,
  },
  /* {
    title: 'Company',
    dataIndex: 'owner__company_id',
    key: 'owner__company_id',
    width: 120,
  }, */
  {
    title: 'Plan Progress',
    dataIndex: 'plan_progress',
    key: 'plan_progress',
    width: 120,
  },
  {
    title: 'Category Progress',
    dataIndex: 'category_progress',
    key: 'category_progress',
    width: 120,
  },
];

const ProjectPlans = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const owner = params.get('owner');
  const company = params.get('company');
  const searchValue = params.get('search');
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchProjectPlans);

  useEffect(() => {
    dispatch(fetchProjectPlans({ owner, owner__company_id: company, search: searchValue, offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [owner, company, searchValue, pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    {
      type: 'search',
      paramName: 'search',
      label: 'Search',
      placeholder: 'Search by name, invited owner and purpose'
    },
    {
      type: 'project-user-select',
      paramName: 'owner',
      placeholder: 'Select user...',
      label: 'Owner'
    },
    {
      type: 'company-select',
      paramName: 'company',
      placeholder: 'Select company...',
      label: 'Company'
    },
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<IProjectPlan>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/project-manager/project-plans/new`}
      filters={filterConfigs}
    />
  );
}

export default ProjectPlans;
